import { styles } from '../../../styles/required-docs.styles';
import { SelectedDoc } from './RequiredDocsSelector';

interface DocsSummaryProps {
  selectedDocs: SelectedDoc[];
  onToggleRequired: (key: string) => void;
  onRemove: (key: string) => void;
}

export function DocsSummary({ selectedDocs, onToggleRequired, onRemove }: DocsSummaryProps) {
  if (selectedDocs.length === 0) return null;

  return (
    <div>
      <div style={styles.sectionTitle}>Documents selectionnes ({selectedDocs.length})</div>
      <div style={{ ...styles.sectionSubtitle, marginBottom: '8px' }}>
        Basculez entre obligatoire et optionnel pour chaque document
      </div>
      <div style={styles.summaryList}>
        {selectedDocs.map((doc) => (
          <div key={doc.key} style={styles.summaryRow}>
            <div style={styles.summaryLeft}>
              <span style={styles.summaryLabel}>{doc.label}</span>
              {doc.acceptedFormats && (
                <span style={{ fontSize: '12px', color: '#9ca3af' }}>({doc.acceptedFormats})</span>
              )}
            </div>
            <div style={styles.summaryRight}>
              <button
                type="button"
                style={doc.isRequired ? styles.pillRequired : styles.pillOptional}
                onClick={() => onToggleRequired(doc.key)}
                title={doc.isRequired ? 'Cliquez pour rendre optionnel' : 'Cliquez pour rendre obligatoire'}
              >
                {doc.isRequired ? 'Obligatoire' : 'Optionnel'}
              </button>
              <button
                type="button"
                style={styles.deleteBtn}
                title={doc.isCustom ? "Supprimer ce document" : "Retirer ce document"}
                onClick={() => onRemove(doc.key)}
              >
                {doc.isCustom ? 'Supprimer' : 'Retirer'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
